import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home as HomeIcon, Search, Heart, TicketCheck, UserCircle2 } from "lucide-react";

/**
 * Phase 13a/13b — shared customer bottom navigation.
 * 5 tabs: Home · Explore · Saved · Coupons · Profile.
 * Visible up to `lg` (matches the reference design).
 */
export function CustomerBottomNav({ homeHref = "/home" }) {
    const loc = useLocation();
    const TABS = [
        { to: homeHref, base: "/home", icon: HomeIcon, label: "Home", testid: "cbn-home" },
        { to: "/posts", base: "/posts", icon: Search, label: "Explore", testid: "cbn-explore" },
        { to: "/customer/favorites", base: "/customer/favorites", icon: Heart, label: "Saved", testid: "cbn-saved" },
        { to: "/customer/coupons", base: "/customer/coupons", icon: TicketCheck, label: "Coupons", testid: "cbn-coupons" },
        { to: "/customer/profile", base: "/customer/profile", icon: UserCircle2, label: "Profile", testid: "cbn-profile" },
    ];
    const isActive = (t) => {
        if (t.base === "/home") return loc.pathname === "/home" || loc.pathname.startsWith("/home/");
        if (t.base === "/posts") return loc.pathname === "/posts" || loc.pathname.startsWith("/posts/");
        return loc.pathname === t.base || loc.pathname.startsWith(t.base + "/");
    };
    return (
        <nav
            className="fixed inset-x-0 bottom-0 z-30 border-t border-[var(--border-soft)] bg-white lg:hidden"
            data-testid="customer-bottom-nav"
        >
            <ul className="flex justify-between px-2">
                {TABS.map((t) => {
                    const active = isActive(t);
                    return (
                        <li key={t.label} className="flex-1">
                            <NavLink
                                to={t.to}
                                data-testid={t.testid}
                                className={`relative flex h-16 flex-col items-center justify-center gap-1 font-body text-[12px] font-medium ${active ? "text-[var(--brand-orange)]" : "text-[var(--text-muted)]"}`}
                            >
                                <t.icon size={20} />
                                <span>{t.label}</span>
                                {active && <span className="absolute bottom-1 h-1 w-1 rounded-full bg-[var(--brand-orange)]" />}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}

export default CustomerBottomNav;
